import React, { useCallback } from 'react';
import { FaMoon, FaSun } from 'react-icons/fa';
import { useAppDispatch, useAppSelector } from '~/shared/hooks/redux';
import { toggleTheme } from '~/rtk-store/theme/slice';
import styles from './style.module.scss';

interface ThemeToggleProps {
    className?: string;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ className }) => {
    const dispatch = useAppDispatch();
    const themeMode = useAppSelector((state) => state.theme.mode);

    const handleToggle = useCallback(() => {
        dispatch(toggleTheme());
    }, [dispatch]);

    const isDark = themeMode === 'dark';

    return (
        <button
            type="button"
            className={`${styles.themeToggle} ${isDark ? styles.dark : styles.light} ${className || ''}`}
            onClick={handleToggle}
            aria-label={isDark ? 'Yorug\' rejimga o\'tish' : 'Tungi rejimga o\'tish'}
            title={isDark ? 'Yorug\' rejimga o\'tish' : 'Tungi rejimga o\'tish'}
        >
            <div className={styles.iconContainer}>
                <FaMoon className={`${styles.icon} ${styles.moonIcon}`} />
                <FaSun className={`${styles.icon} ${styles.sunIcon}`} />
            </div>
        </button>
    );
};

export default ThemeToggle;

